import angular from 'angular';
import moment from "angular-moment";

import chartConfig from './temp-correlation-graph.config';

export class TempCorrelationGraphController {
  /*@ngInject*/
  constructor($scope, $filter) {
    this.$filter = $filter;
    this.chartConfig = chartConfig(this);
    $scope.$watch('$ctrl.data.dailyActivePower', newValue => this.updateGraph(newValue));
  }

  $onInit() {}

  updateGraph(dailyActivePowerData) {
    if (!dailyActivePowerData || !this.chart) {
      return;
    }

    const dailyActivePower = dailyActivePowerData.current;
    const dailyWeather = dailyActivePowerData.currentWeather;
    const graphData = this.createGraphData(dailyActivePower, dailyWeather);

    this.chart.series[0].setData(graphData);
    this.chart.reflow();
  }

  createGraphData(dailyPowers, weathers) {
    if (dailyPowers.length === 0) {
      return [];
    }

    const graphData = [];
    for (let weather of weathers) {
      if (!weather.temp) {
        continue;
      }
      const power = dailyPowers.filter(e => e.date === weather.date)[0];
      if (power) {
        const temp = parseFloat(this.$filter('number')(weather.temp, 1));
        graphData.push({x: temp, y: power.value});
      }
    }

    return graphData;
  }
}

export default angular.module('leptonApp.tempCorrelationGraph', [moment])
  .component('tempCorrelationGraph', {
    template: '<chart value="$ctrl.chartConfig"></chart>',
    controller: TempCorrelationGraphController,
    bindings: {
      data: '='
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/weather-stat-graph/temp-correlation-graph/temp-correlation-graph.component.js